"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.focusNextItem = void 0;
var focusNextItem = exports.focusNextItem = function focusNextItem(metas, next) {
  var _metas$nextElement;
  (_metas$nextElement = metas.nextElement) === null || _metas$nextElement === void 0 || _metas$nextElement.focus({
    preventScroll: true
  });
  next(metas);
};